import React from 'react';
import strings from 'utils/strings';
import './styles.scss';

export const EnvironmentBanner = (props) => {
	return (
		<div className={`environment-banner ${props.environment}`}>
			{strings.formatString(strings.environmentBannerNote, props.environment.toUpperCase())}
		</div>
	);
};
export default EnvironmentBanner;
